import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useState } from 'react';
import { NavLink } from "react-router-dom";
import FeatherIcon from "nood-comp/src/comp/ui/feather-icon/FeatherIcon";
import Spacer from "nood-comp/src/comp/ui/spacer/Spacer";
import * as stylex from '@stylexjs/stylex';
import Icon from "nood-comp/src/comp/ui/feather-icon/Icon";
export default function NavItem(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavLink, {
    to: props.to,
    className: function className(_ref) {
      var isActive = _ref.isActive,
        isPending = _ref.isPending;
      return stylex.props(ui.link, isActive && ui.active).className;
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: props.icon,
    stylexStyles: [isHovered && ui.iconHover],
    size: 20
  }), props.caption && /*#__PURE__*/React.createElement("span", {
    className: 'nav-caption'
  }, props.caption)), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 5
  }));
}
_inject(".ev1h2kqdt{transition:background-color .2s}", 2000);
_inject(".ev16kvzi7{border-radius:var(--more-roundness)}", 2000);
_inject(".ev1ypdohk{cursor:pointer}", 3000);
_inject(".ev7z7khe{padding:10px}", 1000);
_inject(".ev1dfczft:hover{background-color:var(--shade-05)}", 3130);
_inject(".ev1j1efvm:hover{color:var(--shade-80)}", 3130);
_inject("@media(min-width:501px){.ev12kkoxy.ev12kkoxy{background-color:var(--shade-20)}}", 3200);
_inject("@media(min-width:501px){.ev42vduu.ev42vduu{border-radius:var(--more-roundness)}}", 2200);
_inject("@media(min-width:501px){.evuptdu9.evuptdu9{border:0 dotted red}}", 1200);
_inject("@media(min-width:501px){.evhpcvbt.evhpcvbt{color:var(--shade-80)}}", 3200);
_inject("@media(max-width:500px){.ev992iig.ev992iig{color:var(--accent)}}", 3200);
_inject(".ev1b185zu{transition:color .3s}", 2000);
_inject(".evr0sq7q{color:var(--shade-80)}", 3000);
_inject(".ev1hl2dhg{text-decoration:none}", 2000);
_inject(".ev78zum5{display:flex}", 3000);
_inject(".evdt5ytf{flex-direction:column}", 3000);
_inject(".ev1nejdyq{gap:5px}", 2000);
_inject(".ev1blgh98{color:var(--shade-40)}", 3000);
_inject(".ev6s0dn4{align-items:center}", 3000);
_inject(".evl56j7k{justify-content:center}", 3000);
_inject(".ev8fpy8k{border:0 dotted red}", 1000);
_inject(".ev1m3phxg{transition:background-color .1s}", 2000);
_inject(".evp41m2r{padding:12px 0}", 1000);
_inject(".ev10d6zji{margin:3px}", 1000);
_inject("@media (max-width: 500px){.ev1x5x2g4.ev1x5x2g4{flex:1}}", 2200);
_inject("@media (min-width:501px){.ev1f01vmr.ev1f01vmr{background-color:transparent}}", 3200);
_inject("@media (min-width:501px){.eviaksbt.eviaksbt:hover{background-color:var(--shade-10)}}", 3330);
var ui = {
  active: {
    "NavItem__ui.active": "NavItem__ui.active",
    "@media(min-width:501px)_backgroundColor": "ev12kkoxy",
    "@media(min-width:501px)_borderRadius": "ev42vduu",
    "@media(min-width:501px)_borderStartStartRadius": null,
    "@media(min-width:501px)_borderStartEndRadius": null,
    "@media(min-width:501px)_borderEndStartRadius": null,
    "@media(min-width:501px)_borderEndEndRadius": null,
    "@media(min-width:501px)_borderTopLeftRadius": null,
    "@media(min-width:501px)_borderTopRightRadius": null,
    "@media(min-width:501px)_borderBottomLeftRadius": null,
    "@media(min-width:501px)_borderBottomRightRadius": null,
    "@media(min-width:501px)_border": "evuptdu9",
    "@media(min-width:501px)_borderWidth": null,
    "@media(min-width:501px)_borderInlineWidth": null,
    "@media(min-width:501px)_borderInlineStartWidth": null,
    "@media(min-width:501px)_borderLeftWidth": null,
    "@media(min-width:501px)_borderInlineEndWidth": null,
    "@media(min-width:501px)_borderRightWidth": null,
    "@media(min-width:501px)_borderBlockWidth": null,
    "@media(min-width:501px)_borderTopWidth": null,
    "@media(min-width:501px)_borderBottomWidth": null,
    "@media(min-width:501px)_borderStyle": null,
    "@media(min-width:501px)_borderInlineStyle": null,
    "@media(min-width:501px)_borderInlineStartStyle": null,
    "@media(min-width:501px)_borderLeftStyle": null,
    "@media(min-width:501px)_borderInlineEndStyle": null,
    "@media(min-width:501px)_borderRightStyle": null,
    "@media(min-width:501px)_borderBlockStyle": null,
    "@media(min-width:501px)_borderTopStyle": null,
    "@media(min-width:501px)_borderBottomStyle": null,
    "@media(min-width:501px)_borderColor": null,
    "@media(min-width:501px)_borderInlineColor": null,
    "@media(min-width:501px)_borderInlineStartColor": null,
    "@media(min-width:501px)_borderLeftColor": null,
    "@media(min-width:501px)_borderInlineEndColor": null,
    "@media(min-width:501px)_borderRightColor": null,
    "@media(min-width:501px)_borderBlockColor": null,
    "@media(min-width:501px)_borderTopColor": null,
    "@media(min-width:501px)_borderBottomColor": null,
    "@media(min-width:501px)_color": "evhpcvbt",
    "@media(max-width:500px)_color": "ev992iig",
    $$css: true
  },
  iconHover: {
    "NavItem__ui.iconHover": "NavItem__ui.iconHover",
    transition: "ev1b185zu",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    color: "evr0sq7q",
    $$css: true
  },
  link: {
    "NavItem__ui.link": "NavItem__ui.link",
    textDecoration: "ev1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    display: "ev78zum5",
    flexDirection: "evdt5ytf",
    gap: "ev1nejdyq",
    rowGap: null,
    columnGap: null,
    color: "ev1blgh98",
    alignItems: "ev6s0dn4",
    borderRadius: "ev16kvzi7",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    justifyContent: "evl56j7k",
    border: "ev8fpy8k",
    borderWidth: null,
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: null,
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: null,
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    transition: "ev1m3phxg",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    padding: "evp41m2r",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    margin: "ev10d6zji",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    "@media (max-width: 500px)_flex": "ev1x5x2g4",
    "@media (max-width: 500px)_flexGrow": null,
    "@media (max-width: 500px)_flexShrink": null,
    "@media (max-width: 500px)_flexBasis": null,
    "@media (min-width:501px)_backgroundColor": "ev1f01vmr eviaksbt",
    $$css: true
  }
};